import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Impuesto`

export function buscarTodos(idPedido) {
  return http.get(`${API_ENDPOINT}/BuscarTodos/${idPedido}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los impuestos.',
      tipoError: 'impuesto'
    }
  })
}
export function insertar(impuesto) {
  return http.post(`${API_ENDPOINT}/Insertar`, impuesto)
}

export function actualizar(impuesto) {
  return http.put(`${API_ENDPOINT}/Actualizar`, impuesto)
}

export function eliminar(impuesto) {
  return http.delete(`${API_ENDPOINT}/Eliminar`, { data: impuesto })
}

export function obtenerAlicuota(empid) {
  return http.get(`${API_ENDPOINT}/ObtenerAlicuota/${empid}`)
}
